import fabricsDE from '../data/fabrics/de-DE.json';
import fabricsEN from '../data/fabrics/en-EN.json';
import productsDE from '../data/products/de-DE.json';
import productsEN from '../data/products/en-EN.json';
import deDE from '../data/locales/de-DE.json';
import enGB from '../data/locales/en-US.json';
import sewpatsDE from '../data/sewpats/de-DE.json';
import sewpatsEN from '../data/sewpats/en-EN.json';
import StoloSettings from './../settings.json';

export const availableLanguages = {
    de: {
        locale: 'de-DE',
        messages: deDE,
        code: 'de',
        fabrics: fabricsDE,
        sewpats: sewpatsDE,
        products: productsDE,
    },
    en: {
        locale: 'en-GB',
        messages: enGB,
        code: 'en',
        fabrics: fabricsEN,
        sewpats: sewpatsEN,
        products: productsEN,
    },
    fr: {
        lcoale: 'fr-FR',
        messages: deDE,
        code: 'fr',
        fabrics: fabricsEN,
        sewpats: sewpatsEN,
        products: productsEN,
    },
};

export const priceActions = StoloSettings.priceActions;
export const priceScales = StoloSettings.priceScale;
export const {
    sewpatDefaultId, fabricDefaultId, defaultResultLimit, defaultQty,
} = StoloSettings.UISettings;
export const defaultLanguage = availableLanguages[StoloSettings.UISettings.defaultLanguage];
const defaultOptions = new Set(['default']);

export const initialState = {
    i18n: {
        currentLanguage: defaultLanguage,
        fabrics: defaultLanguage.fabrics,
        sewpats: defaultLanguage.sewpats,
        products: defaultLanguage.products,
    },
    cart: {
        qty: defaultQty,
        error: false,
        errorMessage: null,
        help: false,
        helpMessage: null,
    },
    fabric: {
        fabricId: fabricDefaultId,
    },
    sewpat: {
        sewpatId: sewpatDefaultId,
        size: null,
        selectedByUser: false,
        options: defaultOptions,
    },
    product: {
        productId: 'schnoff',
    },
    entities: {
        categories: {
            isFetching: false,
            didInvalidate: false,
            lastFetched: null,
            items: [],
            entities: {},
        },
        patterns: {
            isFetching: false,
            items: [],
            entities: {},
        },
        country: {
            isFetching: false,
            didInvalidate: false,
            items: [],
            entities: {},
        },
        designer: {
            isFetching: false,
            didInvalidate: false,
            items: [],
            entities: {},
        },
    },
    // If you will ever make some of these defaults configurable
    // think of the cache.
    currentQuery: {
        useSecureUrls: true,
        recolorable: true,
    },
    queryCache: {},
    selectedPattern: {
        id: 0,
        thumbnailUri: null,
        sharingImage: null,
    },
    ui: {
        recoloring: {
            displayColorControls: true,
            displayColorpicker: false,
            activeColorSwatch: null,
            colorInputHasFocus: false,
            swatchesToShow: 3,
            showAllSwatches: false,
            resetSliders: false,
            showRecoloringLoader: false,
            thumbnailBase: 20,
            showFigurinePreview: true,
        },
        snackbar: {
            queue: [],
        },
        breakpoint: {
            name: 'smallPortraitOnly',
            data: {
                query: '(max-width: 400px)',
                min: 0,
                max: 400,
                dpi: 1,
                windowHeight: 400,
            },
        },
        siteSearch: {
            hasFocus: false,
            currentSearchValue: '',
        },
        patternGallery: {
            numberPerPage: 12,
            thumbnailType: 'medium', // valid: gallery, medium, xlargeDiscreet
            patternPerPage: defaultResultLimit,
        },
        pagination: {
            type: null,
            page: 1,
            show: false,
        },
        sewpats: {
            figuriStripeCount: 1,
        },
        elements: {

        },
        header: {
            drawerOpen: false,
        },
    },
    navigation: {
        categoriestrail: [],
    },
    colorpicker: {
        color: {
            h: 360,
            s: 0.5,
            l: 0.5,
            a: 1,
        },
    },
    favorites: {
        items: [],
    },
    userdata: {
        selectedSewpatId: null,
        selectedPattern: {
            id: null,
            colors: null,
        },
        selectedFashionSize: null,
        hasSeenHome: 0,
        isSubscribed: false,
    },
};

initialState.currentQuery = Object.defineProperties(initialState.currentQuery, {
    totalHits: {
        value: 0,
        writable: true,
    },
    fetched: {
        value: 0,
        writable: true,
    },
});

export default initialState;



// WEBPACK FOOTER //
// ./src/reducers/initialState.js